module.exports = __webpack_public_path__ + "img/r4.84a53838.jpg";